module.exports = __webpack_public_path__ + "c3b60e5baf238efaccb38767c3ff76bc.MP3";